// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"CustomTableLayout_tabsWrapper__0-9y8","buttonWrapper":"CustomTableLayout_buttonWrapper__znox2"};